import { Component } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'chart-skeleton',
	templateUrl: './chart-skeleton.component.html',
	styleUrls: ['./chart-skeleton.component.scss']
})
export class ChartSkeletonComponent { }
